import React from 'react';
import useOpenRegisterform from './useOpenRegisterform';
import './styles.css';

const RegisterTicketLink = () => {
  const { openLink } = useOpenRegisterform();
  return (
    <div className="registerTicket" data-testid="cmp-register-ticket-link">
      <span>¿No encuentras tu trámite?</span>
      <button
        type="button"
        className="fadeTransition buttonTertiary"
        onClick={openLink}
      >
        Regístralo aquí
      </button>
    </div>
  );
};
export default RegisterTicketLink;
